export enum TemplateView {
  Cart = 'cart',
  CheckOut = 'checkOut',
  DataEntry = 'dataEntry'
}

export enum LeadUiType {
  PO = 'PrivateOffer',
  LF = 'Lead'
}
